import AppHeader from '../AppHeader'

export default {
  name: 'shift-condition',
  created () {
    this.search()
  },
  data () {
    return {
      searchCallbackFlag: false
    }
  },
  computed: {
    shiftConditionUsers () {
      return this.$store.getters.shiftConditionUsers
    },
    shiftClasses () {
      return this.$store.getters.shiftClasses
    }
  },
  components: {
    AppHeader
  },
  methods: {
    search: function() {
      var data = {'shop_id': window.localStorage.getItem('shop_id')}
      var self = this
      var callback = function () {
        self.searchCallbackFlag = true
      }
      this.$store.dispatch('SHIFT_CONDITION_LIST', {data: data, callback: callback} )
    },
    goConditionEdit: function(userId) {
      this.$router.push({ path: '/shift_condition/' + userId +'/edit' })
    },
    goConditionDelete: function(id, name, firstname) {
      if (window.confirm(name + ' ' + firstname + 'さんの条件設定をクリアします')) {
        var data = {
          'user_id': id,
          'shop_id': window.localStorage.getItem('shop_id')
        }
        var self = this
        var callback = function () {
        }
        this.$store.dispatch('SHIFT_CONDITION_DELETE',  {data: data, callback: callback})
      }
    },
    getClassName: function(id) {
      for(var i=0; i < this.$store.getters.shiftClasses.length; i++){
        var shiftClass = this.$store.getters.shiftClasses[i]
        if (shiftClass.id == id) {
          return shiftClass.select_name
        }
      }
      return '設定なし'
    },
    goBack: function() {
      this.$router.push({ path: '/shift_manage'})
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/shift-condition.js